module.exports = __webpack_public_path__ + "img/honor (13).51ced9e5.jpg";